// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import {
  CLEAR_PRICING_MANAGEMENT_STATE,
  SET_PRICING_MANAGEMENT_DATA,
  SET_PRICING_MANAGEMENT_SELECTED_PRICING_GROUP_DEF,
} from './types'

export const clearPricingManagementState = () => ({
  type: CLEAR_PRICING_MANAGEMENT_STATE,
})

export const setPricingManagementData = data => ({
  type: SET_PRICING_MANAGEMENT_DATA,
  data,
})

export const setPricingManagementSelectedPricingGroupDef = (selectedPricingGroupDef = null) => ({
  type: SET_PRICING_MANAGEMENT_SELECTED_PRICING_GROUP_DEF,
  selectedPricingGroupDef,
})
